import i18n from 'modules/core/lib/i18n'

import PerDiemRatesBlock from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/PerDiemRates'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'

interface Props extends PermissionsProps, CustomizationProps {}

const PerDiemRates = (props: Props) => {
  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.per_diem_rates')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.per_diem_rates_subtitle')}
    >
      <PerDiemRatesBlock {...props} loading={false} />
    </FormBlock>
  )
}

export default PerDiemRates
